<app-promo-banners-container />

<router-outlet></router-outlet>

<div class="ind-container-preloader" *ngIf="isLoading">
  <div class="preloader">
    <div class="loader-wrapper">
      <img src="/assets/images/ind-loader.gif" alt="Indiba Loader" />
    </div>
  </div>
</div>

<p-toast [position]="notificationPosition" />
